import { AxiosResponse } from "axios";
import getRapportAar from "./dateUtils";

export const downloadFile = (
  response: AxiosResponse,
  fileEnding: string,
  year: number,
  foreningsNummer: number
) => {
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  const fileName = foreningsNummer > 0
    ? `Rapport-${foreningsNummer}-${new Date().toLocaleDateString()}.${fileEnding}`
    : `Årsrapport-${year-1}.${fileEnding}`;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
};

export const downloadInntektAndKostnadRapport = (
  response: AxiosResponse,
  fileEnding: string,
  foreningsNummer?: number
) => {
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  const fileName = `Regnskapsrapport-${getRapportAar-1}-${
    getRapportAar - 3
  }.${fileEnding}`;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
};
